const BuildSentence = ({sentence}) => {
    return (
        <div className="current-sentece">
            <h3>The {sentence.adjective1} {sentence.noun1} {sentence.adverb} {sentence.verb} the {sentence.adjective2} {sentence.noun2}.</h3>
        </div>
    )
}

export default BuildSentence